import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

// --- Import Komponen ---
import Navbar from "../components/Index/Navbar";
import Footer from "../components/Index/Footer";
import MenuAksiLogin from "../components/Index/menu-aksi-login";
import Testimonials from "../components/Index/Testimonials";
import StepsPage from "../components/Index/Steps-page";

// Import Section
import HomeSection from "../components/Index/Home-section";
import TrustIndicators from "../components/Index/TrustIndicators";
import TutorSection from "../components/Index/Tutor-section";
import ConsultationBanner from "../components/Index/Consultation-section";
import WhyChooseSection from "../components/Index/WhyChoose-section";
import CourseseSection from "../components/Index/Course-section";

const FluenesiaLanding: React.FC = () => {

  // --- Effects ---
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="text-gray-800 safe-area font-poppins overflow-x-hidden w-full relative bg-[#f9fafb]">
      {/* Style tetap dipertahankan */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
        .font-poppins { font-family: 'Poppins', sans-serif; }
        .bg-gradient-custom {
            background: linear-gradient(135deg, #1A4D57 0%, #245A64 75%, #C4A603 100%);
            position: relative; overflow: hidden;
        }
        .bubble {
            position: absolute; background: rgba(255, 255, 255, 0.15); border-radius: 50%;
            pointer-events: none; z-index: 2; animation: float 15s infinite ease-in-out;
            backdrop-filter: blur(4px); border: 1px solid rgba(255, 255, 255, 0.2);
        }
        .tutor-img { filter: grayscale(100%); transition: all 0.5s ease; }
        .tutor-card:hover .tutor-img { filter: grayscale(0%); transform: scale(1.05); }
        @keyframes float {
            0%, 100% { transform: translateY(0) translateX(0) scale(1); }
            33% { transform: translateY(-50px) translateX(30px) scale(1.1); }
            66% { transform: translateY(20px) translateX(-20px) scale(0.9); }
        }
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      <Navbar />

      {/* Di dalam HomeSection inilah tombol "Explore" berada.
         Pastikan di file Home-section.tsx tombolnya menggunakan navigate('/program-selection') 
      */}
      <HomeSection />

      {/* Fase 3: Trust Indicators (As Seen On) */}
      <TrustIndicators />

      <WhyChooseSection />

      <StepsPage />
      <CourseseSection />

      {/* --- BAGIAN KURSUS DIHAPUS DARI SINI --- */}
      {/* Karena user akan di-redirect ke halaman baru, section ini tidak perlu ditampilkan di Home */}

      <ConsultationBanner />
      <TutorSection />
      <Testimonials />
      <MenuAksiLogin />
      <Footer />
    </div>
  );
};

export default FluenesiaLanding;